/** A blob's bytes as plain base64 (no `data:` prefix), for a JSON body. */
export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const url = String(reader.result ?? '');
      resolve(url.slice(url.indexOf(',') + 1));
    };
    reader.onerror = () => reject(reader.error ?? new Error('Could not read the recording'));
    reader.readAsDataURL(blob);
  });
}

/** `audio/webm;codecs=opus` → `audio/webm`: the backend allowlists the bare type. */
export function bareMimeType(type: string): string {
  return type.split(';')[0].trim();
}
